import React from 'react';
import RecentOrder from 'src/components/elements/orderAhead/recentOrder/RecentOrder';
import Localized from 'src/constants/AppStrings';
import {RecentOrderItemType, RecentOrderType} from 'src/types/RecentOrders';
import {Text, View, StyleSheet} from 'react-native';
import Styles from 'src/components/Styles';
import EmptyOrderIcon from 'src/components/img/svg/EmptyOrdersIcon';

export function getRecentOrderListItem(
  item: RecentOrderType,
  addItem: (item: RecentOrderItemType) => void,
  addAllItems: (order: RecentOrderType) => void,
  onProductCellPressed: (item: RecentOrderItemType) => void,
) {
  return (
    <RecentOrder
      recentOrder={item}
      strings={Localized}
      addItem={addItem}
      addAllItems={addAllItems}
      productCellPressed={onProductCellPressed}
    />
  );
}

export function getEmptyList() {
  return (
    <View style={styles.emptyView}>
      <Text
        style={styles.emptyText}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm7}
      >
        {Localized.Labels.no_recent_orders}
      </Text>
      <View style={styles.emptyIcon}>
        <EmptyOrderIcon />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  emptyText: {
    textAlign: 'center',
    color: Styles.Colors.Aramark.black01,
    marginTop: Styles.Spacing.m3,
    fontSize: Styles.Fonts.f1,
    fontWeight: 'bold',
    marginBottom: Styles.Spacing.m3,
    fontFamily: Styles.FontFamily.gothamRegular,
  },
  emptyView: {justifyContent: 'center', flex: 1},
  emptyIcon: {alignSelf: 'center'},
});
export default {
  getRecentOrderListItem,
  getEmptyList,
};
